import { useCountMembersQuery, useCountTeamsQuery, useGetAssignedChannelsCountQuery } from '@/types/generated/graphql';

export function useGetCount() {
  const { data: membersCount } = useCountMembersQuery();
  const { data: teamsCount } = useCountTeamsQuery();
  const { data: channelCount } = useGetAssignedChannelsCountQuery();

  const getCount = (name: string) => {
    switch (name) {
      case 'members':
        return String(membersCount?.countMembers?.data?.find((item) => item?.key === 'accepted')?.value ?? '');
      case 'teams':
        return String(teamsCount?.countTeams?.count);
      case 'channels':
        return Number(channelCount?.getAssignedChannelsCount?.count);
      default:
        return '';
    }
  };
  return getCount;
}
